import { ChangeDetectionStrategy, Component, contentChild, input, output, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@softline/ui-core';

@Component({
  selector: 'soft-query-bar-item',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './query-bar-item.component.html',
  styleUrl: './query-bar-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QueryBarItemComponent {
  readonly icon = input<string>();
  readonly title = input.required<string>();
  readonly value = input<string | number | object | null>();
  readonly readonly = input(false);
  readonly loading = input(false);
  readonly clearable = input(false);

  template = contentChild(TemplateRef)

  readonly onClick = output<void>();
  readonly clear = output<void>();

  //TODO: check if nessasary
  readonly titleClass = input('text-sm');
  readonly valueClass = input('text-sm');
}
